/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-video.vue?vue&type=template&id=5fb227f8&scoped=true"
import script from "./j-video.vue?vue&type=script&lang=js"
export * from "./j-video.vue?vue&type=script&lang=js"
import style0 from "./j-video.vue?vue&type=style&index=0&id=5fb227f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb227f8",
  null
  
)

export default component.exports